import React, { useState } from "react";
import "@/App.css";
import { AppProvider } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { TabBar } from "@/components/TabBar";
import { Toaster } from "@/components/ui/sonner";

import Dashboard from "@/components/tabs/Dashboard";
import Controls from "@/components/tabs/Controls";
import Energy from "@/components/tabs/Energy";
import Grafana from "@/components/tabs/Grafana";
import SettingsTab from "@/components/tabs/SettingsTab";
import Personalize from "@/components/tabs/Personalize";
import AiChat from "@/components/tabs/AiChat";
import About from "@/components/tabs/About";
import CameraTab from "@/components/tabs/CameraTab";
import Gallery from "@/components/tabs/Gallery";
import Contact from "@/components/tabs/Contact";

const TAB_COMPONENTS = {
  dashboard: Dashboard,
  controls: Controls,
  energy: Energy,
  grafana: Grafana,
  settings: SettingsTab,
  personalize: Personalize,
  ai: AiChat,
  about: About,
  camera: CameraTab,
  gallery: Gallery,
  contact: Contact,
};

function Shell() {
  const [tab, setTab] = useState("dashboard");
  const Active = TAB_COMPONENTS[tab];
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--t1)]">
      <Header />
      <TabBar active={tab} onChange={setTab} />
      <main className="max-w-[1500px] mx-auto px-4 sm:px-6 py-6" data-testid={`panel-${tab}`}>
        <Active key={tab} />
      </main>
      <footer className="border-t border-[var(--bd)] mt-10 py-6 text-center text-xs text-[var(--t2)] font-mono">
        Campus Energy Monitor · ESP32 + PZEM-004T ×3 · HiveMQ Cloud · © 2026 Henock HNK · CPUT
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Shell />
      <Toaster position="top-right" />
    </AppProvider>
  );
}
